module.exports = __webpack_public_path__ + "static/media/IMG-7.a4fb3c81.jpg";